// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-icon-text{display:inline-flex;align-items:center}.czt-icon-text--prepend span{padding-left:5px}.czt-icon-text--append{flex-direction:row-reverse}.czt-icon-text--append span{padding-right:5px}", ""]);
// Exports
module.exports = exports;
